function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
     $("body").removeClass("popup-open");
  
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button, .cart-remove-button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        
        if (button.classList.contains("cart-remove-button")) {
          var newQuantity = 0;
        }else{
         var currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
         var isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        var newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
        }
     
        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

  // document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
  //   e.stopPropagation();
  // });

  document
    .querySelectorAll(".cart-drawer-header-right-close")
    .forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
        e.preventDefault();

        console.log('the product is added to the cart..');

        // Get the submit button (assuming it's within the form)
        const submitButton = form.querySelector('input[type="submit"]');

        submitButton.value = "Adding...";

        await fetch("/cart/add", {
            method: "POST",
            body: new FormData(form),
        });

        setTimeout(async () => {
            const res = await fetch("/cart.js");
            const cart = await res.json();
            updateCartItemCounts(cart.item_count);
            await updateCartDrawer();
            openCartDrawer();
            submitButton.value = "Add to Cart";
        }, 100);
    });
});


// document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();

//     var getButton = $(this);

//     console.log('the product is added to the cart..');

//     // Submit form with ajax
//     await fetch("/cart/add", {
//       method: "post",
//       body: new FormData(form),
//     });

//     $("#AddToCart-product-custom-field-template-new").val("Adding...");
    

//     // Get cart count
//     const res = await fetch("/cart.js");
//     const cart = await res.json();
//     updateCartItemCounts(cart.item_count);

//     // Update cart
//     await updateCartDrawer();

//     // Open cart drawer
//     openCartDrawer();
//   });
// });

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});


 $(document).ready(function(){
   $('.addtocart_product').click(function(){
     
     var finalData = { items: []};
   if ($(window).width() < 767) {
     $(".mobile-title .cart-popup__body").find(".cart-popup__item").each(function(){
       var getVarintID = $(this).find('input[name="id"]:checked').val();
      if (typeof getVarintID != "undefined") {
       console.log("getVarintID",getVarintID);
        finalData.items.push({
           'id':getVarintID,
           'quantity': 1
         });
         }
     });
     }else{
      $(".custom-entry .cart-popup__body").find(".cart-popup__item").each(function(){
       var getVarintID = $(this).find('input[name="id"]:checked').val();
      if (typeof getVarintID != "undefined") {
       console.log("getVarintID",getVarintID);
        finalData.items.push({
           'id':getVarintID,
           'quantity': 1
         });
         }
     });
     }
      console.log("finalData",finalData);
    addItemToCart(finalData);
    $(this).find('a').text('Adding...');
   });
  $('.skip_product').click(function(){
     var finalData = { items: []};
   if ($(window).width() < 767) {
     $(".mobile-title .cart-popup__body").find(".current_product_item").each(function(){
       var getVarintID = $(this).find('input[name="id"]:checked').val();
      if (typeof getVarintID != "undefined") {
       console.log("getVarintID",getVarintID);
        finalData.items.push({
           'id':getVarintID,
           'quantity': 1
         });
         }
     });
     }else{
      $(".custom-entry .cart-popup__body").find(".current_product_item").each(function(){
       var getVarintID = $(this).find('input[name="id"]:checked').val();
      if (typeof getVarintID != "undefined") {
       console.log("getVarintID",getVarintID);
        finalData.items.push({
           'id':getVarintID,
           'quantity': 1
         });
         }
     });
     }
      console.log("finalData",finalData);
    addItemToCart(finalData);
   });
   
  });
  function addItemToCart(finalData) {
   jQuery.ajax({
     type: 'POST',
     url: '/cart/add.js',
     data: finalData,
     dataType: 'json',
     success: function(data) {
       console.log("data",data);
      $('.addtocart_product').find('a').text('Add To Cart');
       $(".cart-popup").removeClass("popup-open");
       $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cartdata){
               updateCartItemCounts(cartdata.item_count);
            }
        });

      // Update cart
       updateCartDrawer();
  
      // Open cart drawer
      openCartDrawer();
     }  
   });
  }